const state = {
  riskReport: null,
  creditScore: null,
  riskItems: []
};

const mutations = {
  SET_RISK_REPORT(state, report) {
    state.riskReport = report;
  },
  SET_CREDIT_SCORE(state, score) {
    state.creditScore = score;
  },
  SET_RISK_ITEMS(state, items) {
    state.riskItems = items;
  }
};

const actions = {
  updateRiskReport({ commit }, report) {
    commit('SET_RISK_REPORT', report);
  },
  updateCreditScore({ commit }, score) {
    commit('SET_CREDIT_SCORE', score);
  },
  updateRiskItems({ commit }, items) {
    commit('SET_RISK_ITEMS', items);
  }
};

const getters = {
  riskReport: state => state.riskReport,
  creditScore: state => state.creditScore,
  riskItems: state => state.riskItems
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};